import { render, staticRenderFns } from "./news.vue?vue&type=template&id=1649f8e2"
import script from "./news.vue?vue&type=script&lang=js"
export * from "./news.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1649f8e2')) {
      api.createRecord('1649f8e2', component.options)
    } else {
      api.reload('1649f8e2', component.options)
    }
    module.hot.accept("./news.vue?vue&type=template&id=1649f8e2", function () {
      api.rerender('1649f8e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/teacherMatch/news.vue"
export default component.exports